<template>
  <div class="asd-form">
    <div>
      <label for="login-username">{{ $t('login.mod.in.name') }}</label>
      <input
        id="login-username"
        v-model="credentials.user"
        type="text"
        class="asd-input"
        required="required"
      />
    </div>

    <div>
      <label for="login-username">{{ $t('login.mod.in.pass') }}</label>
      <input
        id="login-password"
        v-model="credentials.password"
        type="password"
        class="asd-input"
        required="required"
        @keydown.enter="login"
      />
    </div>

    <FormControls>
      <ActiveButton class="asd-btn-confirm"
                    :click="login"
      >
        {{ $t("home.sign.in") }}
      </ActiveButton>
    </FormControls>

    <div class="copyright">
      verze {{ VERSION_TAG }}
    </div>
    <div class="password-reset-link" @click="$router.push('/password-reset')">
      zapomenuté heslo
    </div>
  </div>
</template>

<script>
import FormControls from 'CORE/components/form/controls'
import { VERSION_TAG } from '@/versions'
import ActiveButton from 'CORE/components/form/active-button'
import { get } from 'lodash'
import EventBus from 'CORE/bus'

export default {
    name: 'Login',
    components: {
        FormControls,
        ActiveButton,
    },
    data() {
        return {
            credentials: {
                user: '',
                password: '',
            },
        }
    },
    computed: {
        VERSION_TAG() {
            return VERSION_TAG
        },
    },
    methods: {
        async login() {
            try {
                await this.$store.dispatch('currentUserLogin', this.credentials)
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
                // console.info(e)
                // const code = get(e, 'response.status')
                // if (code === 401) {
                //     const msg = get(e, 'response.data.message', 'GENERIC')
                //     console.info(msg)
                //     this.flash(this.$t(`login.errors.${msg}`), 'error', {
                //         timeout: 3000,
                //     })
                // } else {
                //     this.flash(`Chyba ${e}`, 'error', {
                //         timeout: 3000,
                //     })
                // }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.copyright {
    text-align: center;
    font-size: 10px;
    color: var(--color-secondary);
}
.password-reset-link {
    cursor: pointer;
    text-align: center;
    font-size: 10px;
    color: var(--color-secondary);
    &:hover {
        text-decoration: underline;
    }
}
</style>
